import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

function RegisterEmployerStep1() {
  return (
    <>
      <div className="column is-12 container">
        <div className="section">
          <section className="hero is-fullheight">
            <div class="hero-body"></div>
          </section>
        </div>
      </div>
    </>
  );
}

export default RegisterEmployerStep1;
